import { render, staticRenderFns } from "./offDialog.vue?vue&type=template&id=f82c71de&scoped=true&"
import script from "./offDialog.vue?vue&type=script&lang=js&"
export * from "./offDialog.vue?vue&type=script&lang=js&"
import style0 from "./offDialog.vue?vue&type=style&index=0&id=f82c71de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82c71de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f82c71de')) {
      api.createRecord('f82c71de', component.options)
    } else {
      api.reload('f82c71de', component.options)
    }
    module.hot.accept("./offDialog.vue?vue&type=template&id=f82c71de&scoped=true&", function () {
      api.rerender('f82c71de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/components/offDialog.vue"
export default component.exports